module.exports = __webpack_public_path__ + "static/media/kiosk_advertising.f8440264.jpg";